// src/redux/saga/RoomSaga.js
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  submitRoomRequest,
  submitRoomSuccess,
  submitRoomFailure,
  fetchRoomsRequest,
  fetchRoomsSuccess,
  fetchRoomsFailure,
} from "../reducer/RoomReducer";
import { postApi, getApi, postApiV2 } from "../../utils/ApiRequest";

// Selector for token
const getAuthToken = (state) => state.AuthReducer?.loginResponse?.data?.session?.access_token;

// console.log(getAuthToken)

// Header generator
const getAuthHeader = (token) => ({
  Accept: "application/json",
  contenttype: "application/json",
  accesstoken: `${token}`,
});

/**
 * Worker Saga: Fetch All Rooms
 */
function* fetchRoomsSaga() {
  try {
    const token = yield select(getAuthToken);
    const headers = getAuthHeader(token);
    const response = yield call(getApi, "room/AllRoom", headers);

    if (response?.status === 200 || response?.status === 201) {
      yield put(fetchRoomsSuccess(response.data));
    } else {
      yield put(fetchRoomsFailure(response.data));
    }
  } catch (error) {
    yield put(fetchRoomsFailure(error));
  }
}

/**
 * Worker Saga: Submit Room Booking
 */
function* submitRoomSaga(action) {
  try {
    const token = yield select(getAuthToken);
    console.log("Saga token:", token); // ✅ Debug

    if (!token) {
      throw new Error("No token found");
    }

    const headers = getAuthHeader(token);

    const response = yield call(postApiV2, "room/bookings", action.payload, headers);

    if (response?.status === 200 || response?.status === 201) {
      yield put(submitRoomSuccess(response.data));
    } else {
      yield put(submitRoomFailure(response.data));
    }
  } catch (error) {
    console.log("Submit booking failed:", error); // ✅ Debug
    yield put(submitRoomFailure(error));
  }
}

/**
 * Watcher Sagas
 */
function* watchRoomSaga() {
  yield takeLatest("Room/fetchRoomsRequest", fetchRoomsSaga);
  yield takeLatest("Room/submitRoomRequest", submitRoomSaga);
}

export default [watchRoomSaga()];
